export const FINANCING_OPTIONS = {
    investing: 'investing',
    investor_read: 'investor.read',
    borrowing: 'borrowing',
    borrower_read: 'borrower.read',
    solvency_declaration: 'borrower.solvency_declaration',
    loan_application: 'borrower.loan_application',
};
